"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var graphql_tag_1 = require("graphql-tag");
var I18n = require("i18n-js");
var parse_graphql_errors_1 = require("@reverbdotcom/commons/dist/parse_graphql_errors");
var money_1 = require("@reverbdotcom/commons/dist/money");
var form_group_with_input_1 = require("@reverbdotcom/commons/dist/components/form_group_with_input");
var form_group_with_checkbox_1 = require("@reverbdotcom/commons/dist/components/form_group_with_checkbox");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var offer_operations_1 = require("@reverbdotcom/commons/dist/offers/offer_operations");
var rql_1 = require("../../schemas/rql");
var emptyFormState = {
    autoOfferIsActive: false,
    offerPrice: '',
    messageToBuyer: '',
    submitFailedMessage: '',
};
function formReducer(state, action) {
    switch (action.type) {
        case 'prefillFormState':
            if (!action.value.loading && !!action.value.listing.autoOffers.id) {
                return tslib_1.__assign(tslib_1.__assign({}, state), { autoOfferIsActive: true, offerPrice: action.value.listing.autoOffers.price.amount, messageToBuyer: action.value.listing.autoOffers.message });
            }
            return state;
        case 'toggleOfferActive':
            return tslib_1.__assign(tslib_1.__assign({}, state), { autoOfferIsActive: !state.autoOfferIsActive });
        case 'setOfferPrice':
            return tslib_1.__assign(tslib_1.__assign({}, state), { offerPrice: action.value });
        case 'setOfferPriceFromPriceHelper':
            return tslib_1.__assign(tslib_1.__assign({}, state), { offerPrice: discountedPrice(action.value.amountCents, action.value.currency, action.value.percentDiscount) });
        case 'setMessageToBuyer':
            return tslib_1.__assign(tslib_1.__assign({}, state), { messageToBuyer: action.value });
        case 'setSubmitFailedMessage':
            return tslib_1.__assign(tslib_1.__assign({}, state), { submitFailedMessage: action.value });
    }
}
function discountedPrice(amountCents, currency, percentDiscount) {
    var discountedPriceCents = amountCents * (100 - percentDiscount) / 100;
    return money_1.parseAmountCents(discountedPriceCents, currency).amount;
}
function hasAutoOffer(listing) {
    return listing && !!listing.autoOffers.id;
}
function hasDisabledActiveAutoOffer(formState, listing) {
    return !formState.autoOfferIsActive && hasAutoOffer(listing);
}
function NegotiationCountBox(_a) {
    var listing = _a.listing;
    var aggResults = listing.aggregationsBy || [];
    var autoOfferType = aggResults.find(function (_a) {
        var optionValue = _a.optionValue;
        return ("" + optionValue).toUpperCase() === rql_1.core_apimessages_NegotiationType.AUTO_PUSH_OFFER;
    });
    if (!autoOfferType || autoOfferType.count.value < 1)
        return null;
    return (React.createElement("div", null,
        React.createElement("div", { className: "alert-box alert-box--green scaling-mb-2" },
            React.createElement("p", { className: "mb-0" },
                I18n.t('discovery.offers.autoOffers.createForm.sentCount'),
                React.createElement("span", { className: "weight-bold" }, autoOfferType.count.value)))));
}
function PriceHelper(props) {
    var priceHelperAmounts = [10, 15, 20];
    return (priceHelperAmounts.map(function (percentDiscount) { return (React.createElement("button", { key: percentDiscount, className: "button button--small mr-half", type: "button", onClick: function () { return props.dispatch({ type: 'setOfferPriceFromPriceHelper', value: { percentDiscount: percentDiscount, amountCents: props.price.amountCents, currency: props.price.currency } }); } }, I18n.t('discovery.offers.autoOffers.createForm.priceHelper', { percentDiscount: percentDiscount }))); }));
}
function LoadingState() {
    return (React.createElement("div", { className: "align-center" }, I18n.t('discovery.offers.autoOffers.createForm.loading')));
}
function RenderAutoOfferGeneralInformation() {
    return (React.createElement("div", { className: "offers-form__notices alert-box alert-box--gray" },
        React.createElement("p", { className: "offers-form__notice offers-form__notice--watch" }, I18n.t('discovery.offers.autoOffers.createForm.watch')),
        React.createElement("p", { className: "offers-form__notice offers-form__notice--cart" }, I18n.t('discovery.offers.autoOffers.createForm.abandonCart')),
        React.createElement(sanitized_render_1.default, { className: "offers-form__notice offers-form__notice--confirm", htmlTag: "p", html: I18n.t('discovery.offers.autoOffers.createForm.initialSendHtml', {
                tagOpen: '<span class="style-italic">',
                tagClose: '</span>',
            }) }),
        React.createElement("p", { className: "offers-form__notice offers-form__notice--min-price" }, I18n.t('discovery.offers.autoOffers.createForm.minPrice'))));
}
function RenderAutoOfferDetails() {
    return (React.createElement("div", { className: "offers-form__notices" },
        React.createElement("p", { className: "offers-form__notice offers-form__notice--time" }, I18n.t('discovery.offers.autoOffers.createForm.shippingInfo')),
        React.createElement("p", { className: "offers-form__notice offers-form__notice--sale" }, I18n.t('discovery.offers.autoOffers.createForm.saleInfo'))));
}
function AutoOfferForm(_a) {
    var data = _a.data, createAutoOffer = _a.createAutoOffer, deleteAutoOffer = _a.deleteAutoOffer, closeModal = _a.closeModal;
    var _b = React.useReducer(formReducer, emptyFormState), formState = _b[0], dispatch = _b[1];
    React.useEffect(function () { return dispatch({ type: 'prefillFormState', value: data }); }, [data]);
    if (data.loading)
        return LoadingState();
    function handleSubmit(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var err_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        dispatch({ type: 'setSubmitFailedMessage', value: '' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 7, , 8]);
                        if (!hasDisabledActiveAutoOffer(formState, data.listing)) return [3 /*break*/, 3];
                        return [4 /*yield*/, deleteAutoOffer({
                                variables: {
                                    input: {
                                        listingId: data.listing.id,
                                    },
                                },
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, createAutoOffer({
                            variables: {
                                input: {
                                    listingId: data.listing.id,
                                    message: formState.messageToBuyer,
                                    price: money_1.parseAmount(formState.offerPrice, data.listing.price.currency),
                                },
                            },
                        })];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5: 
                    // Refetch from rql so that the form has the saved data if you click back into the
                    // Auto Offer after saving a change.
                    return [4 /*yield*/, data.refetch()];
                    case 6:
                        // Refetch from rql so that the form has the saved data if you click back into the
                        // Auto Offer after saving a change.
                        _a.sent();
                        closeModal();
                        // Reload the page since the indicator UI in the auto offer button comes in as a Rails prop
                        // If we don't reload, the indicator will be out of sync with the current state of the auto offer
                        /* eslint-disable-next-line */
                        location.reload();
                        return [3 /*break*/, 8];
                    case 7:
                        err_1 = _a.sent();
                        dispatch({ type: 'setSubmitFailedMessage', value: parse_graphql_errors_1.parseGraphqlErrors(err_1)[0].message });
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement(React.Fragment, null,
        RenderAutoOfferGeneralInformation(),
        hasAutoOffer(data.listing) && React.createElement(NegotiationCountBox, { listing: data.listing }),
        React.createElement("form", null,
            React.createElement(form_group_with_checkbox_1.default, { inputName: "toggle-auto-offers", label: I18n.t('discovery.offers.autoOffers.createForm.enable'), updateField: function () { return dispatch({ type: 'toggleOfferActive' }); }, checked: formState.autoOfferIsActive }),
            formState.autoOfferIsActive && (React.createElement("div", { className: "scaling-mt-2" },
                formState.submitFailedMessage && (React.createElement("div", { className: "alert-box size-80 scaling-mb-2" },
                    React.createElement("p", { className: "mb-0" }, formState.submitFailedMessage))),
                React.createElement(form_group_with_input_1.default, { value: formState.offerPrice, label: I18n.t('discovery.offers.autoOffers.createForm.price'), inputName: "offerPrice", inputType: "number", currencyPrefix: "$", currencySuffix: data.listing.price.currency, helpText: PriceHelper({ dispatch: dispatch, price: data.listing.price }), autoFocus: true, required: true, updateField: function (_a) {
                        var offerPrice = _a.offerPrice;
                        return dispatch({ type: 'setOfferPrice', value: offerPrice });
                    } }),
                React.createElement(form_group_with_input_1.default, { value: formState.messageToBuyer, label: I18n.t('discovery.offers.autoOffers.createForm.message'), inputName: "messageToBuyer", inputType: "textarea", tagOptional: true, updateField: function (_a) {
                        var messageToBuyer = _a.messageToBuyer;
                        return dispatch({ type: 'setMessageToBuyer', value: messageToBuyer });
                    } }))),
            React.createElement("div", { className: "offers-form__actions" },
                hasDisabledActiveAutoOffer(formState, data.listing) && (React.createElement("div", { className: "alert-box alert-box--yellow size-90 mb-2" },
                    React.createElement("h2", { className: "weight-bold size-120 mb-half icon-l-exclamation-circle" }, I18n.t('discovery.offers.autoOffers.createForm.alertTitle')),
                    React.createElement("p", { className: "mb-0" }, I18n.t('discovery.offers.autoOffers.createForm.alertCopy')))),
                formState.autoOfferIsActive && RenderAutoOfferDetails(),
                React.createElement("button", { className: "offers-form__actions__save", type: "submit", onClick: handleSubmit, disabled: money_1.parseAmount(formState.offerPrice, data.listing.price.currency)
                        .amountCents === 0 }, hasDisabledActiveAutoOffer(formState, data.listing)
                    ? I18n.t('discovery.offers.autoOffers.createForm.save')
                    : I18n.t('discovery.offers.autoOffers.createForm.submit')),
                React.createElement("button", { className: "reverb-modal__actions__back", onClick: closeModal }, I18n.t('discovery.offers.autoOffers.createForm.cancel'))))));
}
exports.AutoOfferForm = AutoOfferForm;
var withListingQuery = react_apollo_1.graphql(graphql_tag_1.default(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    query Core_AutoOffers_ListingDetails($listingId: String) {\n      listing(input: { id: $listingId }) {\n        ...AutoOfferListingFragment\n      }\n    }\n    ", "\n  "], ["\n    query Core_AutoOffers_ListingDetails($listingId: String) {\n      listing(input: { id: $listingId }) {\n        ...AutoOfferListingFragment\n      }\n    }\n    ", "\n  "])), offer_operations_1.AutoOfferListingFragment));
exports.default = react_apollo_1.compose(withListingQuery, offer_operations_1.createAutoOfferMutation, offer_operations_1.deleteAutoOfferMutation)(AutoOfferForm);
var templateObject_1;
//# sourceMappingURL=auto_offer_form.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/listings/auto_offer_form.js
// module id = hgkj
// module chunks = 20 21